var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/lists/components/new_list_form.tsx";
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { changeListEditorTitle, submitListEditor } from 'soapbox/actions/lists';
import { Button, Form, HStack, Input } from 'soapbox/components/ui';
import { useAppSelector } from 'soapbox/hooks';
const messages = defineMessages({
  label: {
    "id": "lists.new.title_placeholder",
    "defaultMessage": "New list title"
  },
  title: {
    "id": "lists.new.create",
    "defaultMessage": "Add list"
  },
  create: {
    "id": "lists.new.create_title",
    "defaultMessage": "Create"
  }
});
const NewListForm = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const value = useAppSelector(state => state.listEditor.get('title'));
  const disabled = useAppSelector(state => !!state.listEditor.get('isSubmitting'));
  const handleChange = e => {
    dispatch(changeListEditorTitle(e.target.value));
  };
  const handleSubmit = e => {
    e.preventDefault();
    dispatch(submitListEditor(true));
  };
  const label = intl.formatMessage(messages.label);
  const create = intl.formatMessage(messages.create);
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: handleSubmit,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    space: 2,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("label", {
    className: "flex-grow",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'none'
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 11
    }
  }, label), /*#__PURE__*/React.createElement(Input, {
    type: "text",
    value: value,
    disabled: disabled,
    onChange: handleChange,
    placeholder: label,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(Button, {
    disabled: disabled,
    onClick: handleSubmit,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 9
    }
  }, create)));
};
export default NewListForm;